import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view03ImageOptions } from './views/exterior_view03'

class Xc47HullTreatment extends Component {
    constructor(props) {
        super(props);
        this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this);
    }


    handleHullTreatmentChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullTreatment = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = exterior_view03ImageOptions;

        let image = (
			<TransomConfigurator colorMultiplier={0.67} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2240, height: 1050 }} transform={
                [
					0.0346, -0.022918, 0, -0.000049,
					-0.003793, 0.055161, 0, -0.000009,
					0, 0, 1, 0,
					204, 152, 0, 1
                ]}>
                <ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
					<h1><Trans defaults='Hull Treatment' /></h1>

					<p><Trans defaults='3 layers of sprayed epoxy primer & 2 layers of antifouling paint' /></p>

                    <RadioGroup label="Treatment options:" options={this.props.hullTreatmentOptions} value={this.props.configuration.HullTreatment} onChange={this.handleHullTreatmentChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47HullTreatment);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47HullTreatment.js